// extracted by mini-css-extract-plugin
module.exports = {"root":"SwiperSlider_root__zAL6Q","navigation":"SwiperSlider_navigation__9tonB","button":"SwiperSlider_button__w6EZu"};